import { apiFetchWikiIndex } from '../../../../../../api'
import { WikiIndexEntryVM } from '../../sidePanel.model'
import { changelogIndexItemsMapperToVM } from './changelog.mapper'

export const fetchChangelogIndex = async (section: string): Promise<WikiIndexEntryVM[]> => {
  const response = await apiFetchWikiIndex()
  return response ? changelogIndexItemsMapperToVM(response, section) : []
}
